module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.svg?3e30e90a9ee4f94765599bcefd758cb3";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.svg
// module id = y7DF
// module chunks = 29